<section class="skeleton-transcription">
    <div 
        *ngFor="let item of [].constructor(9)"
        class="skeleton-list">
        <div 
            class="skeleton-item"
            [ngClass]="{ animation: loadingSkeleton}">
        </div>
    </div>
</section>
